import { ServerComm } from "@quest/platform-murka/dist";

export class GameServerComm extends ServerComm {
  
}